<template>
  <div class="top-tips">
    <div>{{ $t("CommonObject.greeting")}}</div>
    <div>
        <i18n_button></i18n_button>
    </div>
</div>
</template>

<script>

import i18n_button from './i18n_button.vue'
export default {
    components:{
        i18n_button
    }
}
</script>

<style scoped>
    .top-tips{
        display: flex; 
        align-items: center; 
        font-size: 16px;
        justify-content: space-between; 
        height: 50px;
        padding-left: 80px;
        padding-right: 80px;
        background-color: #C6EAFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/lang_top.vue